<template>
  <v-dialog
    v-model="exibedialogInterno"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="fechaDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Cadastro de robo</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="fechaDialog()"
          >
            Fechar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form>
        <v-container class="py-0">
          <v-col
            cols="12"
            md="6"
          >
            <p v-if="erros.length">
              <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
              <ul>
                <li
                  v-for="item in erros"
                  :key="item"
                >
                  {{ item }}
                </li>
              </ul>
            </p>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.nome"
              class="purple-input"
              label="Nome:"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.descricao"
              class="purple-input"
              label="Descrição:"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.ativo"
              readonly
              class="purple-input"
              label="Ativo:"
            />
          </v-col>      
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.uniqueId"
              class="purple-input"
              label="UniqueId:"
            />
          </v-col>              
          <v-col
            class="text-right"
            cols="12"
          >
            <v-btn
              class="mx-0 font-weight-light"
              color="success"
              @click="doSalva"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import service from '../../../services/roboservice'

  export default {
    directives: {
    },
    props: {
      exibedialog: {
        type: Boolean,
        default: false,
      },
      objeto: {
        type: Object,
        default: function () {
          return {
            id: -1,
            nome: '',
            descricao: '',
            ativo: '',
            uniqueId: '',            
          }
        },
      },
    },
    data: () => ({
      form: {
        id: -1,
        nome: '',
        ativo: true,
        descricao: '',
        ativo: '',
        uniqueId: '',        
      },
      exibedialogInterno: false,
      nomeErro: false,
      erros: [],
      menu1: false,
    }),

    watch: {
      exibedialog: function (val) {
        this.exibedialogInterno = val
      },
      objeto: function (val) {
        this.form = val
        if (!this.form) {
          this.iniciaForm()
        }
      },
    },
    mounted () {
      this.iniciaForm()
    },
    methods: {
      iniciaForm () {
        this.form.id = -1,
        this.form.nome = '',
        this.form.periodoNotificacao = ''
        this.form.capacidade =  0
        this.form.tamanho =  0
        this.form.descricao =  ''
        this.form.localizacao =  ''
      },
      fechaDialog () {
        this.exibedialogInterno = false
        this.$emit('update-dialog', this.exibedialogInterno)
      },
      doSalva () {
        if (!this.doValidate()) {
          return
        }

        service.salvar(this.form).then(resposta => {
          if (resposta.status === 200) {
            this.fechaDialog()
            this.iniciaForm()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            console.log('Network Error: ' + e.response)
          } else {
            console.log('Erro ao salvar: ' + e.response)
          }
        })
      },
      doValidate () {
        this.erros = []
        if (!this.form.nome) {
          this.erros.push('Favor preencher: Nome')
        }
        if (this.erros.length === 0) {
          return true
        }
      },
    },
  }
</script>
